import React, { useEffect } from 'react';
import { IRepasseParceiro, IVendaDireta } from '../../../../../../../interfaces/IBaseDeCalculo';
import OperacaoRepasseForm from './components/operacaoRepasseForm/operacaoRepasseForm';
import OperacaoVendaForm from './components/operacaoVendaForm/operacaoVendaForm';
import OperacaoVendaLista from './components/operacaoVendaLista/operacaoVendaLista';
import OperacaoVendaFormReadOnly from './components/operacaoVendaFormReadOnly/operacaoVendaFormReadOnly';
import OperacaoRepasseLista from './components/operacaoRepasseLista/operacaoRepasseLista';
import OperacaoRepasseFormReadOnly from './components/operacaoRepasseFormReadOnly/operacaoRepasseFormReadOnly';

interface ITitularArrendatarioOperacaoComponenteCalculoProps {
  tipoOperacao: 'VENDA_DIRETA_PRIMEIRO_ADQUIRENTE' | 'REPASSE_PARCEIRO' | 'SEM_OPERACAO';
  vendasDiretas: IVendaDireta[];
  setVendaDireta: React.Dispatch<React.SetStateAction<IVendaDireta | undefined>>;
  setVendasDiretas: React.Dispatch<React.SetStateAction<IVendaDireta[]>>;
  repassesParceiros: IRepasseParceiro[];
  setRepassesParceiros: React.Dispatch<React.SetStateAction<IRepasseParceiro[]>>;
  setRepasseParceiro: React.Dispatch<React.SetStateAction<IRepasseParceiro | undefined>>;
  setIsFormularioValido: React.Dispatch<React.SetStateAction<boolean>>;
  stepFormulario: number;
  setMensagemErro: React.Dispatch<React.SetStateAction<string[]>>;
  enableBaseCalculo: boolean;
  vendaDireta: IVendaDireta | undefined;
  repasseParceiro: IRepasseParceiro | undefined;
  setIsEdicaoBaseCalculo: React.Dispatch<React.SetStateAction<boolean>>;
  setVendaDiretaEdicao: React.Dispatch<React.SetStateAction<IVendaDireta | undefined>>;
  setRepasseParceiroEdicao: React.Dispatch<React.SetStateAction<IRepasseParceiro | undefined>>;
  vendaDiretaEdicao?: IVendaDireta;
  repasseParceiroEdicao?: IRepasseParceiro;
}

const TitularArrendatarioOperacaoComponenteCalculo: React.FC<ITitularArrendatarioOperacaoComponenteCalculoProps> = ({
  tipoOperacao,
  vendasDiretas,
  setVendaDireta,
  repassesParceiros,
  setRepasseParceiro,
  setIsFormularioValido,
  stepFormulario,
  setMensagemErro,
  enableBaseCalculo,
  vendaDireta,
  repasseParceiro,
  setRepassesParceiros,
  setVendasDiretas,
  setIsEdicaoBaseCalculo,
  setVendaDiretaEdicao,
  setRepasseParceiroEdicao,
  vendaDiretaEdicao,
  repasseParceiroEdicao,
}) => {
  const headersVendaDireta = [
    { field: 'tipoOperacao', label: 'Tipo de Operação', classe: 'w6' },
    { field: 'cpfCnpj', label: 'CPF/CNPJ', classe: 'w6' },
    { field: 'nomeRazaoSocial', label: 'Nome/Razão Social', classe: 'w6' },
  ];

  const headersRepasseParceiro = [
    { field: 'cpfCnpj', label: 'CPF/CNPJ', classe: 'w6' },
    { field: 'nomeRazaoSocial', label: 'Nome/Razão Social', classe: 'w6' },
    { field: 'tipoVinculo', label: 'Tipo de Vínculo', classe: 'w3' },
    { field: 'descricaoVinculo', label: 'Descrição do Vínculo', classe: 'w3' },
    { field: 'endereco', label: 'Endereço', classe: 'w3' },
    { field: 'transportador', label: 'Transportador', classe: 'w3' },
    {
      field: 'nomeRazaoSocialTransportador',
      label: 'Nome/Razão Social do Transportador',
      classe: 'w3',
    },
    {
      field: 'cpfCnpjTransportador',
      label: 'CPF/CNPJ do Transportador',
      classe: 'w3',
    },
    {
      field: 'enderecoTransportador',
      label: 'Endereço do Transportador',
      classe: 'w3',
    },
    { field: 'localEntrega', label: 'Local de Entrega Repasse', classe: 'w3' },
  ];

  useEffect(() => {
    setIsEdicaoBaseCalculo(false);
    if (vendaDiretaEdicao || repasseParceiroEdicao) {
      setIsEdicaoBaseCalculo(true);
    }
  }, [vendaDiretaEdicao, repasseParceiroEdicao]);

  return (
    <div>
      {tipoOperacao === 'VENDA_DIRETA_PRIMEIRO_ADQUIRENTE' ? (
        <div>
          <OperacaoVendaLista
            vendasDiretas={vendasDiretas}
            setVendasDiretas={setVendasDiretas}
            setVendaDiretaEdicao={setVendaDiretaEdicao}
            vendaDiretaEdicao={vendaDiretaEdicao}
            vendaDiretaCadastro={vendaDireta}
            headers={headersVendaDireta}
          />
          {stepFormulario === 2 && enableBaseCalculo ? (
            <OperacaoVendaForm
              setVendaDireta={setVendaDireta}
              setIsFormularioValido={setIsFormularioValido}
              setMensagemErro={setMensagemErro}
              vendaDiretaEdicao={vendaDiretaEdicao}
            />
          ) : (
            <OperacaoVendaFormReadOnly vendaDireta={vendaDireta} />
          )}
        </div>
      ) : (
        tipoOperacao === 'REPASSE_PARCEIRO' && (
          <div>
            <OperacaoRepasseLista
              repassesParceiros={repassesParceiros}
              setRepassesParceiros={setRepassesParceiros}
              repasseParceiroEdicao={repasseParceiroEdicao}
              repasseParceiroCadastro={repasseParceiro}
              setRepasseParceiroEdicao={setRepasseParceiroEdicao}
              headers={headersRepasseParceiro}
            />
            {stepFormulario === 2 && enableBaseCalculo ? (
              <OperacaoRepasseForm
                setRepasseParceiro={setRepasseParceiro}
                setIsFormularioValido={setIsFormularioValido}
                setMensagemErro={setMensagemErro}
                repasseParceiroEdicao={repasseParceiroEdicao}
              />
            ) : (
              <OperacaoRepasseFormReadOnly repasseParceiro={repasseParceiro} />
            )}
          </div>
        )
      )}
    </div>
  );
};

export default TitularArrendatarioOperacaoComponenteCalculo;
